import React, { useState } from 'react';
import Tile from '../ui/Tile';
import TileHeader from '../ui/TileHeader';
import { History } from 'lucide-react';
import HistoryToolbar from './components/HistoryToolbar';
import HistoryTable from './components/HistoryTable';
import HistoryPagination from './components/HistoryPagination';
import InvoiceFilters from './components/InvoiceFilters';

const InvoicesHistory = ({
  title,
  invoiceLabel,
  invoices = [],
  page,
  setPage,
  totalPages,
  totalElements,
  setSize,
  handleGeneratePdf,
  handleDownloadPdf,
  handleDownloadPdfBulk,
  handleLoadInvoiceToForm,
  handleDeleteInvoice,
  handleUpdateInvoice,
  sorting,
  setSorting,
  filters,
  setFilters,
  bankDetails
}) => {
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [showFilters, setShowFilters] = useState(false);

  const handleCheckboxChange = (invoiceId, checked) => {
    setSelectedInvoices(prev =>
      checked ? [...prev, invoiceId] : prev.filter(id => id !== invoiceId)
    );
  };

  const allSelected = invoices.length > 0 && selectedInvoices.length === invoices.length;

  const handleSelectAllToggle = () => {
    if (allSelected) {
      setSelectedInvoices([]);
    } else {
      setSelectedInvoices(invoices.map(inv => inv.id));
    }
  };

  const handleLoadAll = () => {
    if (setSize && setPage && totalElements) {
      setSize(totalElements);
      setPage(0);
    }
  };

  const onBulkDownload = () => {
    if (handleDownloadPdfBulk) {
      const selectedInvoicesList = invoices.filter(invoice =>
        selectedInvoices.includes(invoice.id)
      );
      handleDownloadPdfBulk(selectedInvoicesList);
    }
  };

  return (
    <div className="w-full mt-8">
      <Tile>
        <TileHeader title={title || 'Последно издадени'} icon={History} />
        <HistoryToolbar 
          selectedCount={selectedInvoices.length} 
          loadedCount={invoices.length}
          totalCount={totalElements || invoices.length}
          onBulkDownload={onBulkDownload} 
          onToggleFilters={() => setShowFilters(!showFilters)}
          showFilters={showFilters}
          hasFilters={!!setFilters}
          onLoadAll={handleLoadAll}
          onSelectAll={handleSelectAllToggle}
          allSelected={allSelected}
        />
        {showFilters && setFilters && (
          <InvoiceFilters 
            filters={filters} 
            setFilters={setFilters} 
            onClose={() => setShowFilters(false)} 
          />
        )}
        <HistoryTable 
          invoiceLabel={invoiceLabel}
          invoices={invoices}
          selectedInvoices={selectedInvoices}
          handleCheckboxChange={handleCheckboxChange}
          sorting={sorting}
          setSorting={setSorting}
          handleGeneratePdf={handleGeneratePdf}
          handleDownloadPdf={handleDownloadPdf}
          handleDeleteInvoice={handleDeleteInvoice}
          handleUpdateInvoice={handleUpdateInvoice}
          handleLoadInvoiceToForm={handleLoadInvoiceToForm}
          bankDetails={bankDetails}
        />
        <HistoryPagination 
          page={page} 
          setPage={setPage} 
          totalPages={totalPages} 
        />
      </Tile>
    </div>
  );
};

export default InvoicesHistory;
